import { render } from "./komoIndex.vue?vue&type=template&id=01eed907&scoped=true"
import script from "./komoIndex.vue?vue&type=script&lang=js"
export * from "./komoIndex.vue?vue&type=script&lang=js"

import "./komoIndex.vue?vue&type=style&index=0&id=01eed907&lang=less"
import "./komoIndex.vue?vue&type=style&index=1&id=01eed907&scoped=true&lang=css"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01eed907"]])

export default __exports__